module.exports = __webpack_public_path__ + "overons.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/overons.png
// module id = 634
// module chunks = 0